import * as React from 'react';

interface BreadcrumbsData {
  title: string;
  backTo: string;
  badges?: React.ReactNode[];
  rightContent?: React.ReactNode;
}

interface BreadcrumbsContextValue {
  breadcrumbs: BreadcrumbsData | null;
  setBreadcrumbs: (data: BreadcrumbsData | null) => void;
}

const BreadcrumbsContext = React.createContext<BreadcrumbsContextValue>({
  breadcrumbs: null,
  setBreadcrumbs: () => undefined,
});

export const BreadcrumbsProvider: React.FC = ({ children }) => {
  const [breadcrumbs, setBreadcrumbs] = React.useState<BreadcrumbsData | null>(
    null,
  );

  return (
    <BreadcrumbsContext.Provider value={{ breadcrumbs, setBreadcrumbs }}>
      {children}
    </BreadcrumbsContext.Provider>
  );
};

export const useBreadcrumbs = ({
  title,
  backTo,
  badges,
  rightContent,
}: BreadcrumbsData) => {
  const { setBreadcrumbs } = React.useContext(BreadcrumbsContext);

  React.useEffect(() => {
    setBreadcrumbs({ title, backTo, badges, rightContent });
    return () => setBreadcrumbs(null);
  }, [setBreadcrumbs, title, backTo, badges, rightContent]);
};

export const useBreadcrumbsContext = () => React.useContext(BreadcrumbsContext);

export const useBreadcrumbsData = () =>
  React.useContext(BreadcrumbsContext).breadcrumbs;
